"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lottieWeb = _interopRequireDefault(require("lottie-web"));

var _stitches = require("../../stitches.config");

var StyledLottieWrapper = (0, _stitches.styled)('div', {});
/**
 * An element used to display a lottie animation.
 */

var Lottie = function Lottie(_ref) {
  var css = _ref.css,
      path = _ref.path,
      title = _ref.title;
  var element = (0, _react.useRef)(null);
  var lottieInstance = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (element.current) {
      lottieInstance.current = _lottieWeb.default.loadAnimation({
        autoplay: true,
        container: element.current,
        loop: true,
        path: path
      });
    }

    return function () {
      lottieInstance.current.destroy();
    };
  }, [element, path]);
  return /*#__PURE__*/_react.default.createElement(StyledLottieWrapper, {
    css: css,
    ref: element,
    title: title
  });
};

Lottie.defaultProps = {
  css: null,
  title: ''
};
var _default = Lottie;
exports.default = _default;